import { Dialog, useTheme } from "@mui/material";
import * as React from "react";

import styles from "./AgentThreadSidebar.module.css";
import { AgentThreadSidebarControls } from "./AgentThreadSidebarControls";
import { AgentThreadSidebarMainContent } from "./AgentThreadSidebarMainContent";

interface AgentThreadFullscreenModalProps {
  open: boolean;
  onClose: () => void;
}

export const AgentThreadFullscreenModal: React.FC<
  AgentThreadFullscreenModalProps
> = ({ open, onClose }) => {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen
      sx={{
        zIndex: theme.zLayer(10),
      }}
    >
      <div className={styles.container}>
        <AgentThreadSidebarControls onClose={onClose} />

        <AgentThreadSidebarMainContent />
      </div>
    </Dialog>
  );
};
